import React from 'react';
import { ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import Rodal from '../Rodal/Rodal';
import './RejectionReasonDialog.scss';

interface RejectionReasonDialogProps {
    isVisible: boolean;
    reason: string;
    isBuyerFeedback?: boolean;
    onClose: () => void;
}

const RejectionReasonDialog = ({
    isVisible,
    reason,
    isBuyerFeedback,
    onClose,
}: RejectionReasonDialogProps) => {
    if (!isVisible) {
        return null;
    }

    return (
        <Rodal
            visible={true}
            animation="slideTop"
            width={498}
            showCloseButton={false}
            onClose={onClose}
            className="confirmation-modal rejection-reason-dialog">
            <ModalHeader>Rejection Reason</ModalHeader>
            <ModalBody>
                {isBuyerFeedback && (
                    <div className="rejection-reason-source">
                        The buyer left this feedback when rejecting the
                        opportunity:
                    </div>
                )}
                <span className="rejection-reason-text">{reason}</span>
            </ModalBody>
            <ModalFooter>
                <Button
                    type="button"
                    className="btn-cancel"
                    onClick={onClose}>
                    Close
                </Button>
            </ModalFooter>
        </Rodal>
    );
};

export default RejectionReasonDialog;
